const keyManagerModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/key-manager-modal/key-manager-modal.html',
  controller: 'KeyManagerModalController',
};

angular
  .module('modalDirectives')
  .component('keyManagerModal', keyManagerModal);
